// removed by extract-text-webpack-plugin
module.exports = {"Hero":"src-components-SuccessStories-Hero----Hero-module---Hero---3dbc4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SuccessStories/Hero/Hero.module.scss
// module id = 377
// module chunks = 20587081441290 36625128905600